/**
 * Payment methods a customer can pay Edge with.
 * Mirrors the backend Customer_Payroll.Payment_Method enum
 * (backend/app/customers2/enums/customer.enum.ts).
 */
export const PAYMENT_METHODS = {
  WIRE: "wire",
  CHEQUE: "cheque",
  CREDIT_CARD: "credit_card",
  ACH: "ach",
} as const;

export const NO_PAYMENT_METHOD_LABEL = "-";

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  [PAYMENT_METHODS.WIRE]: "Wire Transfer",
  [PAYMENT_METHODS.CHEQUE]: "Cheque",
  [PAYMENT_METHODS.CREDIT_CARD]: "Credit Card",
  [PAYMENT_METHODS.ACH]: "ACH",
};

/** Display label for a payment method; "-" when absent or unrecognised. */
export const getPaymentMethodLabel = (method?: string | null): string =>
  (method && PAYMENT_METHOD_LABELS[method]) || NO_PAYMENT_METHOD_LABEL;

/**
 * Methods an admin can record manually when updating a payment status.
 * Card and ACH are excluded: those are collected automatically via Stripe.
 */
export const PAYMENT_METHOD_OPTIONS = [
  { value: PAYMENT_METHODS.WIRE, label: PAYMENT_METHOD_LABELS[PAYMENT_METHODS.WIRE] },
  { value: PAYMENT_METHODS.CHEQUE, label: PAYMENT_METHOD_LABELS[PAYMENT_METHODS.CHEQUE] },
];
